<template>
  <form-element v-bind="$props">
    <label class="checkbox">
      <div class="checkbox__field">
        <div class="checkbox__icon" :class="{ checked: state }">
          <dotcom-icon
            :key="state"
            :name="state ? 'square-check' : 'square'"
            :art="state ? 'solid' : 'light'"
            :color="state ? '--c-primary-color-2' : '--c-primary-neutral-1'"
          />
        </div>
        <input
          v-model="state"
          :name="name"
          :value="value"
          :disabled="disabled"
          type="checkbox"
          class="checkbox__input"
          @change="$emit('input', state)"
        />
        <span v-if="text" class="checkbox__label" v-html="text" />
      </div>
    </label>
  </form-element>
</template>

<script>
import FormElement from '../FormElement'

export default {
  name: 'Checkbox',

  components: {
    FormElement,
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },

  props: {
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Object, Number, Boolean],
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    tooltipContent: {
      type: String,
      default: '',
    },
    tooltipLabel: {
      type: String,
      default: '',
    },
    errors: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return { state: this.value }
  },

  watch: {
    value(value) {
      this.state = value
    },
  },
}
</script>

<style scoped lang="postcss">
.checkbox {
  display: inline-flex;
  flex-direction: row;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
  height: auto;
  flex-wrap: wrap;

  & > *,
  & >>> * {
    pointer-events: none;
  }
}

.checkbox__field {
  display: flex;
}

.checkbox__icon {
  height: 100%;
}

.checkbox__icon >>> .dotcom-icon {
  font-size: 24px;
}

.checkbox__input {
  cursor: pointer;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;

  &:hover {
    &:after {
      opacity: 0.3;
    }
  }

  &:checked {
    &:after {
      opacity: 1;
    }
  }
}

.checkbox__label {
  margin-left: 12px;
  line-height: 24px;
}

label.checkbox {
  &:hover {
    .checkbox__icon::after {
      content: '';
      background-color: var(--c-primary-neutral-1);
      opacity: 0.05;
      border-radius: 100%;
      display: inline-block;
      width: 40px;
      height: 40px;
      position: absolute;
      top: -7.8px;
      left: -9.5px;
    }

    .checkbox__icon.checked::after {
      background-color: var(--c-primary-color-2);
    }
  }

  &:active {
    .checkbox__icon::after {
      opacity: 0.2;
    }

    .checkbox__icon.checked::after {
      background-color: var(--c-primary-color-2);
    }
  }

  &:focus {
    /* outline: 2px dotted var(--c-primary-neutral-1); */
  }
}

.form-element.checkboxGroup-item {
  margin-bottom: 12px;
}
</style>
